var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#c00",
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-377.000000, -3855.000000)",
    fill: "inherit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.-Checklist",
    transform: "translate(356.000000, 3544.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1.1,
    transform: "translate(21.000000, 305.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,24.6250005 L3,24.6250005 L3,24.6250005 C1.34315,24.6250005 0,23.28185 0,21.6250005 C0,21.6250005 0,21.6250005 0,21.6250005 L0,9.62500045 L0,9.62500045 C0,7.96815045 1.34315,6.62500045 3,6.62500045 L15,6.62500045 L15,6.62500045 C16.6568499,6.62500045 18,7.96815045 18,9.62500045 L18,21.6250005 L18,21.6250005 C18,23.2818505 16.6568499,24.6250005 15,24.6250005 L15,24.6250005 Z M3.00000009,8.625 L3.00000009,8.625 C2.44771509,8.625 2.00000009,9.072715 2.00000009,9.625 C2.00000009,9.625 2.00000009,9.625 2.00000009,9.625 L2.00000009,21.625 L2.00000009,21.625 C2.00000009,22.1772852 2.44771509,22.625 3.00000009,22.625 L15.0000001,22.625 L15.0000001,22.625 C15.552285,22.625 16.0000001,22.1772852 16.0000001,21.625 L16.0000001,9.625 L16.0000001,9.625 C16.0000001,9.07271515 15.552285,8.625 15.0000001,8.625 L3.00000009,8.625 Z",
    id: "Fill"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/Square.bd9a1bc6.svg";
export { ForwardRef as ReactComponent };